var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { longModeRatio } from '../variables';
import getRotateSize from './getRotateSize';
/**
 * 获取图片合适的大小
 */
export default function getSuitableImageSize(naturalWidth, naturalHeight, rotate) {
    var _a = __read(getRotateSize(rotate, window.innerWidth, window.innerHeight), 3), currentWidth = _a[0], currentHeight = _a[1], isVertical = _a[2];
    var y = 0;
    var width = currentWidth;
    var height = currentHeight;
    // 自适应宽高
    var autoWidth = (naturalWidth / naturalHeight) * currentHeight;
    var autoHeight = (naturalHeight / naturalWidth) * currentWidth;
    if (naturalWidth < currentWidth && naturalHeight < currentHeight) {
        width = naturalWidth;
        height = naturalHeight;
    }
    else if (naturalWidth < currentWidth && naturalHeight >= currentHeight) {
        width = autoWidth;
    }
    else if (naturalWidth >= currentWidth && naturalHeight < currentHeight) {
        height = autoHeight;
    }
    else if (naturalWidth / naturalHeight > currentWidth / currentHeight) {
        height = autoHeight;
    }
    // 长图模式
    else if (naturalHeight / naturalWidth >= longModeRatio && !isVertical) {
        height = autoHeight;
        y = (height - currentHeight) / 2;
    }
    else {
        width = autoWidth;
    }
    return {
        width: width,
        height: height,
        x: 0,
        y: y,
        pause: true,
    };
}
